import React from "react";

export default function ProphetMuhammadFrame3({ frameTextToggle, children }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 2000 2000"
      width="300"
      height="300"
      fill="none"
    >
      <g transform={frameTextToggle}>
        <defs>
          <style>{".cls-prop31{fill:#c3821a}.cls-prop34{fill:#b56b00}"}</style>
        </defs>
        <path
          d="M1769.48 1145.55h5v6h-5zM1774.48 1133.58h-5v-11.97h5v11.97Zm0-23.94h-5v-11.97h5v11.97Zm0-23.94h-5v-11.97h5v11.97Zm0-23.94h-5v-11.97h5v11.97Zm0-23.94h-5v-11.97h5v11.97ZM1769.48 1007.89h5v6h-5zM1006.06 1673.84l-220.08-235.47-322.12 10.89 10.89-322.12-235.47-220.08 235.47-220.08-10.89-322.12 322.12 10.89 220.08-235.47 220.08 235.47 322.12-10.89-10.89 322.12 235.47 220.08-235.47 220.08 10.89 322.12-322.12-10.89-220.08 235.47Zm-199.61-284.89 199.61 213.58 199.61-213.58 292.17 9.87-9.87-292.17 213.57-199.61-213.57-199.61 9.87-292.17-292.17 9.87-199.61-213.57-199.61 213.57-292.17-9.87 9.87 292.17-213.57 199.61 213.57 199.61-9.87 292.17 292.17-9.87Z"
          className="cls-prop31"
        />
        <path
          d="m1006.06 1599.95-198.87-212.78-291.08 9.84 9.84-291.08-212.78-198.87 212.78-198.87-9.84-291.08 291.08 9.84 198.87-212.78 198.87 212.78 291.08-9.84-9.84 291.08 212.78 198.87-212.78 198.87 9.84 291.08-291.08-9.84-198.87 212.78Zm-180.38-257.43 180.38 193 180.38-193 264.01 8.92-8.92-264.01 192.99-180.38-192.99-180.38 8.92-264.01-264.01 8.92-180.38-193-180.38 193-264.01-8.92 8.92 264.01L377.6 907.05l192.99 180.38-8.92 264.01 264.01-8.92Z"
          style={{
            fill: "#25215c",
          }}
        />
        <path
          d="M245.05 1195.28h5v6h-5zM250.05 1183.01h-5v-12.3h5v12.3Zm0-24.6h-5v-12.3h5v12.3Zm0-24.59h-5v-12.29h5v12.29Zm0-24.58h-5v-12.29h5v12.29Zm0-24.58h-5v-12.29h5v12.29Zm0-24.56h-5v-12.3h5v12.3Zm0-24.59h-5v-12.29h5v12.29Zm0-24.58h-5v-12.29h5v12.29Zm0-24.58h-5v-12.29h5v12.29Zm0-24.59h-5v-12.3h5v12.3Zm0-24.59h-5v-12.3h5v12.3ZM245.05 907.05h5v6h-5zM464.38 1562.13h5v6h-5zM469.38 1550.16h-5v-11.97h5v11.97Zm0-23.94h-5v-11.97h5v11.97Zm0-23.94h-5v-11.97h5v11.97Zm0-23.94h-5v-11.97h5v11.97Zm0-23.94h-5v-11.97h5v11.97ZM464.38 1424.48h5v6h-5zM1003.56 1749.65h5v6h-5zM1008.56 1737.68h-5v-11.97h5v11.97Zm0-23.94h-5v-11.97h5v11.97Zm0-23.94h-5v-11.97h5v11.97Zm0-23.94h-5v-11.97h5v11.97Zm0-23.94h-5v-11.97h5v11.97ZM1003.56 1612h5v6h-5zM1543.01 1573.12h5v6h-5zM1548.01 1561.15h-5v-11.97h5v11.97Zm0-23.94h-5v-11.97h5v11.97Zm0-23.94h-5v-11.97h5v11.97Zm0-23.94h-5v-11.97h5v11.97Zm0-23.94h-5v-11.97h5v11.97ZM1543.01 1435.47h5v6h-5z"
          className="cls-prop31"
        />
        <path
          d="m1006.06 1617.12-203.8-218.06-298.3 10.08 10.08-298.3-218.06-203.8 218.06-203.8-10.08-298.3 298.3 10.08 203.8-218.06 203.8 218.06 298.3-10.08-10.08 298.3 218.06 203.8-218.06 203.8 10.08 298.3-298.3-10.08-203.8 218.06Zm-194.53-240.44 194.53 208.14 194.53-208.14 284.73 9.62-9.62-284.73 208.14-194.53-208.14-194.53 9.62-284.73-284.73 9.62-194.53-208.14L811.53 437.4l-284.73-9.62 9.62 284.73-208.14 194.53 208.14 194.53-9.62 284.73 284.73-9.62Z"
          style={{
            fill: "#fff",
          }}
        />
        <path
          d="m247.55 1112.32 30.23 61.26 67.6 9.82-48.91 47.68 11.54 67.33-60.46-31.79-60.46 31.79 11.54-67.33-48.91-47.68 67.6-9.82 30.23-61.26z"
          className="cls-prop31"
        />
        <path
          d="m247.55 1204.9-30.23-31.79 30.23-61.25v93.04zM345.38 1183.4l-97.83 21.96 30.23-31.78 67.6 9.82z"
          className="cls-prop34"
        />
        <path
          d="m308.01 1297.94-60.46-93.04 48.92 25.72 11.54 67.32z"
          className="cls-prop34"
        />
        <path
          d="m187.09 1297.94 60.46-93.04v61.26l-60.46 31.78zM149.72 1182.94l97.83 21.96-48.92 25.72-48.91-47.68z"
          className="cls-prop34"
        />
        <path
          d="m466.88 1530.94 18.35 37.19 41.05 5.97-29.7 28.95 7.01 40.88-36.71-19.3-36.71 19.3 7.01-40.88-29.7-28.95 41.04-5.97 18.36-37.19z"
          className="cls-prop31"
        />
        <path
          d="m466.88 1587.15-18.36-19.3 18.36-37.19v56.49zM526.28 1574.1l-59.4 13.33 18.35-19.3 41.05 5.97z"
          className="cls-prop34"
        />
        <path
          d="m503.59 1643.65-36.71-56.5 29.7 15.62 7.01 40.88zM430.17 1643.65l36.71-56.5v37.2l-36.71 19.3zM407.48 1573.82l59.4 13.33-29.7 15.62-29.7-28.95z"
          className="cls-prop34"
        />
        <path
          d="m1770.45 1044.74 24.67 49.99 55.16 8.01-39.92 38.91 9.43 54.95-49.34-25.94-49.34 25.94 9.42-54.95-39.92-38.91 55.17-8.01 24.67-49.99z"
          className="cls-prop31"
        />
        <path
          d="m1770.45 1120.29-24.67-25.94 24.67-49.99v75.93zM1850.28 1102.74l-79.83 17.93 24.67-25.94 55.16 8.01z"
          className="cls-prop34"
        />
        <path
          d="m1819.79 1196.22-49.34-75.93 39.91 20.99 9.43 54.94zM1721.11 1196.22l49.34-75.93v49.99l-49.34 25.94zM1690.61 1102.37l79.84 17.92-39.92 20.99-39.92-38.91z"
          className="cls-prop34"
        />
        <path
          d="m1006.06 1742.26 19.09 38.67 42.68 6.2-30.88 30.11 7.29 42.5-38.18-20.07-38.17 20.07 7.29-42.5-30.88-30.11 42.68-6.2 19.08-38.67z"
          className="cls-prop31"
        />
        <path
          d="m1006.06 1800.71-19.08-20.07 19.08-38.67v58.74zM1067.83 1787.13l-61.77 13.87 19.09-20.07 42.68 6.2z"
          className="cls-prop34"
        />
        <path
          d="m1044.24 1859.45-38.18-58.74 30.89 16.23 7.29 42.51zM967.89 1859.45l38.17-58.74v38.67l-38.17 20.07zM944.3 1786.84l61.76 13.87-30.88 16.23-30.88-30.1z"
          className="cls-prop34"
        />
        <path
          d="m1545.51 1543.07 28.43 57.61 63.58 9.24-46.01 44.85 10.86 63.32-56.86-29.9-56.86 29.9 10.86-63.32-46.01-44.85 63.58-9.24 28.43-57.61z"
          className="cls-prop31"
        />
        <path
          d="m1545.51 1630.14-28.43-29.89 28.43-57.61v87.5zM1637.52 1609.92l-92.01 20.66 28.43-29.9 63.58 9.24z"
          className="cls-prop34"
        />
        <path
          d="m1602.37 1717.65-56.86-87.51 46 24.19 10.86 63.32zM1488.65 1717.65l56.86-87.51v57.61l-56.86 29.9zM1453.5 1609.49l92.01 20.65-46 24.19-46.01-44.84z"
          className="cls-prop34"
        />
        {children}
      </g>
    </svg>
  );
}
